<template>
  <section>
    <qx-tab :tabs="tabs" v-model="activeTab" />
    <ContentBox
      v-for="(item, index) in tabs"
      :key="index"
      v-show="activeTab === item.value"
      :isShow="activeTab === item.value"
      :activeTab="activeTab"
      :tabVal="item.value"
    />
  </section>
</template>

<script>
import ContentBox from './content';
export default {
  components: {
    ContentBox,
  },
  data () {
    return {
      activeTab: '1',
      tabs: [
        {
          label: '待我处理',
          value: '1',
        },
        {
          label: '我发起的',
          value: '2',
        },
      ],
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
</style>
